export default {"src":"/_next/static/media/storage.638ae96a.svg","height":67,"width":66};